export default "__VITE_ASSET__DIDuitRN__"